import React from 'react';
import PropTypes from 'prop-types';
import Chip from '@mui/material/Chip';

const propTypes = {
  value: PropTypes.string,
};

const defaultProps = {
  value: '',
};

const StatusRenderer = (props) => {
  const { value } = props;
  if (value === '') {
    return null;
  }
  const getChipStyle = () => {
    const style = {
      height: '25px',
      borderRadius: '6px',
    };
    if (value === 'In Progress') {
      style.backgroundColor = '#E5F2FE';
      style.color = '#303AD6';
    } else if (value === 'Not Started') {
      style.backgroundColor = '#EAECF0';
      style.color = '#101828';
    } else if (value === 'Completed') {
      style.backgroundColor = '#E9FFE3';
      style.color = '#399700';
    }
    return style;
  };
  return <Chip sx={getChipStyle()} label={value} />;
};

StatusRenderer.propTypes = propTypes;
StatusRenderer.defaultProps = defaultProps;
export default StatusRenderer;
